import * as types from './mutations-type'
import _ from 'lodash'

const mutations = {
    [types.SECTORS](state, payload) {
        if (payload.length > 0) {
            _.forEach(payload, function (o) {
                state.sectors.push({ text: o.sectorName, value: o.sectorID, sectorWorksiteVoluntary: o.sectorWorksiteVoluntary })
            })
        }
    },
    [types.CATEGORY](state, payload) {
        state.category = []
        if (payload.length > 0) {
            _.forEach(payload, function (o) {
                state.category.push({ text: o.sectorName, value: o.sectorID, sectorWorksiteVoluntary: o.sectorWorksiteVoluntary })
            })
        }
    },
    [types.SUB_CATEGORY](state, payload) {
        state.sub_category = []
        if (payload.length > 0) {
            _.forEach(payload, function (o) {
                state.sub_category.push({ text: o.sectorName, value: o.sectorID, sectorWorksiteVoluntary: o.sectorWorksiteVoluntary })
            })
        }
    },
    [types.SUB_SUB_CATEGORY](state, payload) {
        state.sub_sub_category = []
        if (payload.length > 0) {
            _.forEach(payload, function (o) {
                state.sub_sub_category.push({ text: o.sectorName, value: o.sectorID, sectorWorksiteVoluntary: o.sectorWorksiteVoluntary })
            })
        }
    },
    [types.SECTORPRED](state, payload) {
        state.sec_pred = payload
    },
    [types.CATEGORYPRED](state, payload) {
        state.cat_pred = payload
    },
    [types.MAILINGTYPEPRED](state, payload) {
        state.mailing_type_pred = payload
    },
    [types.SECCOMPANYPRED](state, payload) {
        state.sec_company_pred = payload
    },
    [types.RAW_DATA](state, payload) {
        state.raw_data = payload
    },
    [types.PRODUCT_ISMOBILE](state, payload) {
        state.data.ismobile = payload
    },
    [types.PRODUCT_ISPRESCREEN](state, payload) {
        state.data.isprescreen = payload
    },
    [types.PRODUCT_GROUP_SIZE](state, payload) {
        state.data.group_size = payload
    },
    [types.PRODUCT_FACE_AMOUNT](state, payload) {
        state.data.face_amount = payload
    },
    [types.PRODUCT_TERM_LENGTH](state, payload) {
        state.data.term_length = payload
    },
    [types.PRODUCT_ISSUE_TYPE](state, payload) {
        state.data.issue_type = payload
    },
    [types.PRODUCT_RIDERS](state, payload) {
        state.data.riders = payload
    },
    [types.PRODUCT_PANELISTS](state, payload) {
        let f = state.data.panelists.find(o => (o.competi_id === payload.competi_id && o.invitation_id === payload.invitation_id &&
            o.panelist_id === payload.panelist_id && o.pp_date === payload.pp_date && o.tracking_id === payload.tracking_id))
        typeof f === 'undefined' ? state.data.panelists.push(payload) : ''
    },
    [types.PRODUCT_STATE_SPECIFIC](state, payload) {
        if (payload == 1) {
            payload = true
        }
        if (payload == 0) {
            payload = false
        }
        state.data.state_specific = payload
    },
    [types.PRODUCT_ENTRYDATE](state, payload) {
        state.data.entrydate = payload
    },
    [types.PRODUCT_OFFER_EXPIRY_DATE](state, payload) {
        state.data.offer_expiry_date = payload
    },
    [types.PRODUCT_VARIENT_ID](state, payload) {
        state.data.varient_id = payload
    },
    [types.PRODUCT_VARIANT_TYPE](state, payload) {
        state.data.variant_type = payload
    },
    [types.PRODUCT_COMPANIES](state, payload) {
        state.data.companies = payload
    },
    [types.PRODUCT_PRODUCT_IMAGE](state, payload) {
        state.data.product_image = payload
    },
    [types.PRODUCT_IMG](state, payload) {
        state.data.product_img = payload
    },
    [types.PRODUCT_AFFINITY](state, payload) {
        state.data.affinity = payload
    },
    [types.PRODUCT_MEDIA_CHAN](state, payload) {
        state.data.media_chan = payload
    },
    [types.PRODUCT_AUDIENCE](state, payload) {
        state.data.audience = payload
    },
    [types.PRODUCT_SECTOR_DISPLAYABLE](state, payload) {
        state.sectorsData = []
        state.sectorsData = payload
    },
    [types.PRODUCT_SECTOR_SUBMITTABLE](state, payload) {
        state.data.sectors = payload
    },
    // [types.PRODUCT_SUBCATEGORY] (state, payload) {
    //     state.data.subcategory = payload
    // },
    // [types.PRODUCT_SUBSUBCATEGORY] (state, payload) {
    //     state.data.subsubcategory = payload
    // },
    [types.PRODUCT_OFFER_ORIGIN](state, payload) {
        state.data.offer_origin = payload
    },
    [types.PRODUCT_PRODUCT_NAME](state, payload) {
        state.data.product_name = payload
    },
    [types.PRODUCT_PRODUCT_HEADLINE](state, payload) {
        state.data.product_headline = payload
    },
    [types.PRODUCT_WORKTYPE_VOLUNTARY](state, payload) {
        state.data.worktype_voluntary = payload
    },
    [types.PRODUCT_PRESCREEN_OPNOTICE](state, payload) {
        state.data.prescreen_opnotice = payload
    },
    [types.PRODUCT_FEE_PRODUCT](state, payload) {
        state.data.fee_product = payload
    },
    [types.PRODUCT_FAUX_CHECK](state, payload) {
        state.data.faux_check = payload
    },
    [types.PRODUCT_TIP_ON_CARD](state, payload) {
        state.data.tip_on_card = payload;
      },
    [types.PRODUCT_HANDWRITING](state, payload) {
        state.data.handwriting = payload;
      },
    [types.PRODUCT_PERSCRIPTION](state, payload) {
        state.data.prescription = payload
    },
    [types.PRODUCT_IS_HPHSA](state, payload) {
        state.data.is_hphsa = payload
    },
    [types.PRODUCT_ANCILARY_PRODUCTS](state, payload) {
        state.data.ancilary_products = payload
    },
    [types.PRODUCT_RESPONSE_MECHANISM](state, payload) {
        state.data.response_mechanism = payload
    },
    [types.PRODUCT_BUSINESS_CONTENT](state, payload) {
        state.data.business_content = payload
    },
    [types.PRODUCT_PERSONALIZATION](state, payload) {
        state.data.personalization = payload
    },
    [types.PRODUCT_MAILING_TYPE](state, payload) {
        state.data.mailing_type = payload
    },
    [types.PRODUCT_COMMUNICATION_TYPE](state, payload) {
        state.data.communication_type = payload
    },
    [types.PRODUCT_OBSERVED_TRAFFIC_SOURCE](state, payload) {
        state.data.observed_traffic_source = payload
    },
    [types.PRODUCT_DM_TM_SOURCE](state, payload) {
        state.data.dm_tm_source = payload
    },

    [types.SIGN_ON_1_INCENTIVE](state, payload) {
        state.data.sign_on_1.sign_on_incentive = payload
    },
    [types.ONGOING_INCENTIVE](state, payload) {
        state.data.sign_on_1.ongoing_incentive = payload
    },
    [types.SIGN_ON_1_INCENTIVE_TYPE](state, payload) {
        state.data.sign_on_1.sign_on_incentive_type = payload
    },
    [types.SIGN_ON_1_INCENTIVE_VALUE](state, payload) {
        state.data.sign_on_1.sign_on_incentive_value = payload
    },
    [types.SIGN_ON_1_ACCELERETOR_PER](state, payload) {
        state.data.sign_on_1.sign_on_acceleretor_per = payload
    },
    [types.SIGN_ON_1_ACCELERETOR_TYPE](state, payload) {
        state.data.sign_on_1.sign_on_acceleretor_type = payload
    },
    [types.SIGN_ON_1_MAX_AWARD](state, payload) {
        state.data.sign_on_1.sign_on_max_award = payload
    },
    [types.SIGN_ON_1_INCENTIVE_MAX_SPEND](state, payload) {
        state.data.sign_on_1.sign_on_incentive_max_spend = payload
    },
    [types.SIGN_ON_1_INCENTIVE_MIN_SPEND](state, payload) {
        state.data.sign_on_1.sign_on_incentive_min_spend = payload
    },
    [types.SIGN_ON_1_INCENTIVE_WINDOW_MONTH](state, payload) {
        state.data.sign_on_1.sign_on_incentive_window_month = payload
    },
    [types.SIGN_ON_1_LIMIT_SPECIFIC_CATEGORY](state, payload) {
        state.data.sign_on_1.sign_on_limit_specific_category = payload
    },
    [types.SIGN_ON_1_FIXED_DATE](state, payload) {
        state.data.sign_on_1.sign_on_fixed_date = payload
    },

    [types.SIGN_ON_2_INCENTIVE](state, payload) {
        state.data.sign_on_2.sign_on_incentive = payload
    },
    [types.SIGN_ON_2_INCENTIVE_TYPE](state, payload) {
        state.data.sign_on_2.sign_on_incentive_type = payload
    },
    [types.SIGN_ON_2_INCENTIVE_VALUE](state, payload) {
        state.data.sign_on_2.sign_on_incentive_value = payload
    },
    [types.SIGN_ON_2_ACCELERETOR_PER](state, payload) {
        state.data.sign_on_2.sign_on_acceleretor_per = payload
    },
    [types.SIGN_ON_2_ACCELERETOR_TYPE](state, payload) {
        state.data.sign_on_2.sign_on_acceleretor_type = payload
    },
    [types.SIGN_ON_2_MAX_AWARD](state, payload) {
        state.data.sign_on_2.sign_on_max_award = payload
    },
    [types.SIGN_ON_2_INCENTIVE_MAX_SPEND](state, payload) {
        state.data.sign_on_2.sign_on_incentive_max_spend = payload
    },
    [types.SIGN_ON_2_INCENTIVE_MIN_SPEND](state, payload) {
        state.data.sign_on_2.sign_on_incentive_min_spend = payload
    },
    [types.SIGN_ON_2_INCENTIVE_WINDOW_MONTH](state, payload) {
        state.data.sign_on_2.sign_on_incentive_window_month = payload
    },
    [types.SIGN_ON_2_LIMIT_SPECIFIC_CATEGORY](state, payload) {
        state.data.sign_on_2.sign_on_limit_specific_category = payload
    },
    [types.SIGN_ON_2_FIXED_DATE](state, payload) {
        state.data.sign_on_2.sign_on_fixed_date = payload
    },

    [types.SIGN_ON_3_INCENTIVE](state, payload) {
        state.data.sign_on_3.sign_on_incentive = payload
    },
    [types.SIGN_ON_3_INCENTIVE_TYPE](state, payload) {
        state.data.sign_on_3.sign_on_incentive_type = payload
    },
    [types.SIGN_ON_3_INCENTIVE_VALUE](state, payload) {
        state.data.sign_on_3.sign_on_incentive_value = payload
    },
    [types.SIGN_ON_3_ACCELERETOR_PER](state, payload) {
        state.data.sign_on_3.sign_on_acceleretor_per = payload
    },
    [types.SIGN_ON_3_ACCELERETOR_TYPE](state, payload) {
        state.data.sign_on_3.sign_on_acceleretor_type = payload
    },
    [types.SIGN_ON_3_MAX_AWARD](state, payload) {
        state.data.sign_on_3.sign_on_max_award = payload
    },
    [types.SIGN_ON_3_INCENTIVE_MAX_SPEND](state, payload) {
        state.data.sign_on_3.sign_on_incentive_max_spend = payload
    },
    [types.SIGN_ON_3_INCENTIVE_MIN_SPEND](state, payload) {
        state.data.sign_on_3.sign_on_incentive_min_spend = payload
    },
    [types.SIGN_ON_3_INCENTIVE_WINDOW_MONTH](state, payload) {
        state.data.sign_on_3.sign_on_incentive_window_month = payload
    },
    [types.SIGN_ON_3_LIMIT_SPECIFIC_CATEGORY](state, payload) {
        state.data.sign_on_3.sign_on_limit_specific_category = payload
    },
    [types.SIGN_ON_3_FIXED_DATE](state, payload) {
        state.data.sign_on_3.sign_on_fixed_date = payload
    },

    [types.PRODUCT_CAMPAIGN_LANGUAGE](state, payload) {
        state.data.campaign_language = payload
    },
    [types.PRODUCT_TARGET_MARKET](state, payload) {
        state.data.target_market = payload
    },
    [types.PRODUCT_STATE_PROVINCE](state, payload) {
        state.data.state_province = payload
    },
    [types.PRODUCT_PRIMARY_COUNTRY](state, payload) {
        state.data.primary_country = payload
    },
    [types.PRODUCT_GENDER](state, payload) {
        state.data.gender = payload
    },
    [types.PRODUCT_AGE](state, payload) {
        state.data.age = payload
    },
    [types.PRODUCT_INCOME](state, payload) {
        state.data.income = payload
    },
    [types.PRODUCT_CITI](state, payload) {
        state.data.citi = payload
    },
    [types.PRODUCT_ON_HOME_PAGE](state, payload) {
        state.data.on_home_page = payload
    },
    [types.PRODUCT_HIGH_PRIORITY](state, payload) {
        state.data.high_priority = payload
    },

    [types.BANKING_REWARD_PROGRAM_EMPHASIS](state, payload) {
        state.data.banking.reward_program_emphasis = payload
    },
    [types.BANKING_REWARD_PROGRAM](state, payload) {
        state.data.banking.reward_program = payload
    },
    [types.BANKING_CARD_TYPE](state, payload) {
        state.data.banking.card_type = payload
    },
    [types.BANKING_DEBIT_CARD_MENTIONED](state, payload) {
        state.data.banking.debit_card_mentioned = payload
    },
    [types.BANKING_CD_APY](state, payload) {
        state.data.banking.cd_apy = payload
    },
    [types.BANKING_CD_APR](state, payload) {
        state.data.banking.cd_apr = payload
    },
    [types.BANKING_MONEY_MARKET_APY](state, payload) {
        state.data.banking.money_market_apy = payload
    },
    [types.BANKING_MONEY_MARKET_APR](state, payload) {
        state.data.banking.money_market_apr = payload
    },
    [types.BANKING_SAVING_APY](state, payload) {
        state.data.banking.saving_apy = payload
    },
    [types.BANKING_SAVING_APR](state, payload) {
        state.data.banking.saving_apr = payload
    },
    [types.BANKING_CHECKING_APY](state, payload) {
        state.data.banking.checking_apy = payload
    },
    [types.BANKING_CHECKING_APR](state, payload) {
        state.data.banking.checking_apr = payload
    },
    [types.BANKING_FREE_CHECKING](state, payload) {
        state.data.banking.free_checking = payload
    },
    [types.BANKING_MINIMUM_DEPOSIT](state, payload) {
        state.data.banking.minimum_deposit = payload
    },
    /////////////////////////credit card/////////////////////////////////////////
    [types.CREDIT_CARD_PROMOTIONAL_OFFER](state, payload) {
        state.data.credit_card.promotional_offer = payload
    },
    ///balance transfer introductory
    [types.CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTION_APR](state, payload) {
        state.data.credit_card.tier_1_balance_transfer_introduction_apr = payload
    },
    [types.CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_1_balance_transfer_introductory_period = payload
    },
    [types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTION_APR](state, payload) {
        state.data.credit_card.tier_2_balance_transfer_introduction_apr = payload
    },
    [types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_2_balance_transfer_introductory_period = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.credit_card.PromotionalOfferUsageFee = payload
    },
    [types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.credit_card.tier_2_balance_transfer_introductory_usage_fee = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.credit_card.PromotionalOfferMinimumFee = payload
    },
    [types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.credit_card.tier_2_balance_transfer_introductory_minimum_fee = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE](state, payload) {
        state.data.credit_card.PromotionalOfferMaximumFee = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD](state, payload) {
        state.data.credit_card.balance_transfer_introductory_fee_period = payload
    },

    //cash advance
    [types.CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_APR](state, payload) {
        state.data.credit_card.tier_1_cash_advance_introductory_apr = payload
    },
    [types.CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_1_cash_advance_introductory_period = payload
    },
    [types.CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_APR](state, payload) {
        state.data.credit_card.tier_2_cash_advance_introductory_apr = payload
    },
    [types.CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_2_cash_advance_introductory_period = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.credit_card.cash_advance_introductory_usage_fee = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.credit_card.cash_advance_introductory_minimum_fee = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE](state, payload) {
        state.data.credit_card.cash_advance_introductory_maximum_fee = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD](state, payload) {
        state.data.credit_card.cash_advance_introductory_fee_period = payload
    },

    //purchase

    [types.CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_APR](state, payload) {
        state.data.credit_card.tier_1_purchase_introductory_apr = payload
    },
    [types.CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_1_purchase_introductory_period = payload
    },
    [types.CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_APR](state, payload) {
        state.data.credit_card.tier_2_purchase_introductory_apr = payload
    },
    [types.CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_PERIOD](state, payload) {
        state.data.credit_card.tier_2_purchase_introductory_period = payload
    },
    [types.CREDIT_CARD_PURCHASE_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.credit_card.purchase_introductory_usage_fee = payload
    },
    [types.CREDIT_CARD_PURCHASE_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.credit_card.purchase_introductory_minimum_fee = payload
    },
    [types.CREDIT_CARD_PURCHASE_INTRODUCTORY_MAXIMUM_FEE](state, payload) {
        state.data.credit_card.purchase_introductory_maximum_fee = payload
    },
    [types.CREDIT_CARD_PURCHASE_INTRODUCTORY_FEE_PERIOD](state, payload) {
        state.data.credit_card.purchase_introductory_fee_period = payload
    },

    //regular pricing
    [types.CREDIT_CARD_BALANCE_TRANSFER_REGULAR_APR](state, payload) {
        state.data.credit_card.balance_transfer_regular_apr = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE](state, payload) {
        state.data.credit_card.balance_transfer_regular_rate_type = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_USAGE_FEE](state, payload) {
        state.data.credit_card.balance_transfer_usage_fee = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_MINIMUM_FEE](state, payload) {
        state.data.credit_card.balance_transfer_minimum_fee = payload
    },
    [types.CREDIT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE](state, payload) {
        state.data.credit_card.balance_transfer_maximum_fee = payload
    },
    //cash advance regular pricing
    [types.CREDIT_CARD_CASH_ADVANCE_REGULAR_APR](state, payload) {
        state.data.credit_card.cash_advance_regular_apr = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE](state, payload) {
        state.data.credit_card.cash_advance_regular_rate_type = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_USAGE_FEE](state, payload) {
        state.data.credit_card.cash_advance_usage_fee = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_MINIMUM_FEE](state, payload) {
        state.data.credit_card.cash_advance_minimum_fee = payload
    },
    [types.CREDIT_CARD_CASH_ADVANCE_MAXIMUM_FEE](state, payload) {
        state.data.credit_card.cash_advance_maximum_fee = payload
    },

    // ----- purchase regular pricing
    [types.CREDIT_CARD_PERCHASE_REGULAR_APR](state, payload) {
        state.data.credit_card.perchase_regular_apr = payload
    },
    [types.CREDIT_CARD_PERCHASE_REGULAR_RATE_TYPE](state, payload) {
        state.data.credit_card.perchase_regular_rate_type = payload
    },
    ///////////////////////////////////////////////////////////////////////////

    [types.DELIVERY_DELIVERY_METHOD](state, payload) {
        state.data.delivery.delivery_method = payload
    },
    [types.DELIVERY_DELIVERY_TYPE](state, payload) {
        state.data.delivery.delivery_type = payload
    },
    [types.DELIVERY_POSTAGE](state, payload) {
        state.data.delivery.postage = payload
    },
    [types.DELIVERY_PRE_SORTED](state, payload) {
        state.data.delivery.pre_sorted = payload
    },
    [types.DELIVERY_PACKAGE_TYPE](state, payload) {
        state.data.delivery.package_type = payload
    },

    [types.ENERGY_OFFER_PRICE_PER_KWH](state, payload) {
        state.data.energy.offer_price_per_kwh = payload
    },
    [types.ENERGY_OFFER_PRICE_PER_KWH2](state, payload) {
        state.data.energy.offer_price_per_kwh2 = payload
    },
    [types.ENERGY_OFFER_PRICE_PER_KWH3](state, payload) {
        state.data.energy.offer_price_per_kwh3 = payload
    },
    [types.ENERGY_OFFER_PRICE_PER_KWH4](state, payload) {
        state.data.energy.offer_price_per_kwh4 = payload
    },
    [types.ENERGY_TERM_LENGTH](state, payload) {
        state.data.energy.term_length = payload
    },
    [types.ENERGY_TERM_LENGTH2](state, payload) {
        state.data.energy.term_length2 = payload
    },
    [types.ENERGY_TERM_LENGTH3](state, payload) {
        state.data.energy.term_length3 = payload
    },
    [types.ENERGY_TERM_LENGTH4](state, payload) {
        state.data.energy.term_length4 = payload
    },
    [types.ENERGY_CANCEL_FEE](state, payload) {
        state.data.energy.cancel_fee = payload
    },
    [types.ENERGY_CANCEL_FEE_DETAILS](state, payload) {
        state.data.energy.cancel_fee_details = payload
    },
    [types.ENERGY_RATE_TYPE](state, payload) {
        state.data.energy.rate_type = payload
    },
    [types.ENERGY_RATE_TYPE2](state, payload) {
        state.data.energy.rate_type2 = payload
    },
    [types.ENERGY_RATE_TYPE3](state, payload) {
        state.data.energy.rate_type3 = payload
    },
    [types.ENERGY_RATE_TYPE4](state, payload) {
        state.data.energy.rate_type4 = payload
    },

    [types.MEDIA_CHANNEL_ELECTRONIC_TYPE](state, payload) {
        state.data.media_channel.electronic_type = payload
    },
    [types.MEDIA_CHANNEL_DIGITAL_SOURCE](state, payload) {
        state.data.media_channel.digital_source = payload
    },
    [types.MEDIA_CHANNEL_NUMBER_UPDATES_TWEETS](state, payload) {
        state.data.media_channel.number_updates_tweets = payload
    },
    [types.MEDIA_CHANNEL_NUMBER_FANS_FOLLOWERS](state, payload) {
        state.data.media_channel.number_fans_followers = payload
    },
    [types.MEDIA_CHANNEL_EXTERNAL_LINK](state, payload) {
        state.data.media_channel.external_link = payload
    },
    [types.MEDIA_CHANNEL_SOCIAL_MEDIA_ADD_TYPE](state, payload) {
        state.data.media_channel.social_media_add_type = payload
    },

    [types.MORTGAGE_LOANS_REFINANCE](state, payload) {
        state.data.mortgage_loans.refinance = payload
    },
    [types.MORTGAGE_LOANS_JUMBO_NON_CONFORMING](state, payload) {
        state.data.mortgage_loans.jumbo_non_conforming = payload
    },
    [types.MORTGAGE_LOANS_VA](state, payload) {
        state.data.mortgage_loans.va = payload
    },
    [types.MORTGAGE_LOANS_FHA](state, payload) {
        state.data.mortgage_loans.fha = payload
    },
    [types.MORTGAGE_LOANS_CONVENTIONAL](state, payload) {
        state.data.mortgage_loans.conventional = payload
    },
    [types.MORTGAGE_LOANS_USDA](state, payload) {
        state.data.mortgage_loans.usda = payload
    },
    [types.MORTGAGE_LOANS_CORRESPONDENT_LENDING](state, payload) {
        state.data.mortgage_loans.correspondent_lending = payload
    },
    [types.MORTGAGE_LOANS_APPLICATION_TYPE](state, payload) {
        state.data.mortgage_loans.application_type = payload
    },
    [types.MORTGAGE_LOANS_OFFERED_LOAN_AMOUNT](state, payload) {
        state.data.mortgage_loans.offered_loan_amount = payload
    },
    [types.MORTGAGE_LOANS_MAXIMUM_LOAN_AMOUNT](state, payload) {
        state.data.mortgage_loans.maximum_loan_amount = payload
    },
    [types.MORTGAGE_LOANS_MINIMUM_LOAN_AMOUNT](state, payload) {
        state.data.mortgage_loans.minimum_loan_amount = payload
    },
    [types.MORTGAGE_LOANS_LOAN_TERM_MONTHS](state, payload) {
        state.data.mortgage_loans.loan_term_months = payload
    },
    [types.MORTGAGE_LOANS_OFFERED_APR](state, payload) {
        state.data.mortgage_loans.offered_apr = payload
    },
    [types.MORTGAGE_LOANS_UPPER_APR](state, payload) {
        state.data.mortgage_loans.upper_apr = payload
    },
    [types.MORTGAGE_LOANS_LOWER_APR](state, payload) {
        state.data.mortgage_loans.lower_apr = payload
    },
    [types.MORTGAGE_LOANS_RATE_TYPE](state, payload) {
        state.data.mortgage_loans.rate_type = payload
    },
    [types.MORTGAGE_LOANS_INTRODUCTORY_APR](state, payload) {
        state.data.mortgage_loans.introductory_apr = payload
    },
    [types.MORTGAGE_LOANS_INTRODUCTORY_PERIOD_MONTHS](state, payload) {
        state.data.mortgage_loans.introductory_period_months = payload
    },

    [types.PAYMENT_CARD_APPLICATION_TYPE](state, payload) {
        state.data.payment_card.application_type = payload
    },
    [types.PAYMENT_CARD_CARD_NETWORK](state, payload) {
        state.data.payment_card.card_network = payload
    },
    [types.PAYMENT_CARD_PRIMARY_CARD_LEVEL](state, payload) {
        state.data.payment_card.primary_card_level = payload
    },
    [types.PAYMENT_CARD_SECONDARY_CARD_LEVEL](state, payload) {
        state.data.payment_card.secondary_card_level = payload
    },
    [types.PAYMENT_CARD_REWARD_PROGRAM](state, payload) {
        state.data.payment_card.reward_program = payload
    },
    [types.PAYMENT_CARD_REWARD_PROGRAM_EMPHASIS](state, payload) {
        state.data.payment_card.reward_program_emphasis = payload
    },
    [types.PAYMENT_CARD_REWARD_PROGRAM_RATE](state, payload) {
        state.data.payment_card.reward_program_rate = payload
    },
    [types.PAYMENT_CARD_RELOADABLE](state, payload) {
        state.data.payment_card.reloadable = payload
    },
    [types.PAYMENT_CARD_TIER_1_PURCHASE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_1_purchase_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_2_PURCHASE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_2_purchase_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_3_PURCHASE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_3_purchase_regular_apr = payload
    },
    [types.PAYMENT_CARD_PURCHASE_REGULAR_APR_DETAIL](state, payload) {
        state.data.payment_card.purchase_regular_apr_detail = payload
    },
    [types.PAYMENT_CARD_PERCHASE_REGULAR_RATE_TYPE](state, payload) {
        state.data.payment_card.perchase_regular_rate_type = payload
    },
    [types.PAYMENT_CARD_TIER_1_BALANCE_TRANSFER_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_1_balance_transfer_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_2_BALANCE_TRANSFER_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_2_balance_transfer_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_3_BALANCE_TRANSFER_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_3_balance_transfer_regular_apr = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_APR_DETAIL](state, payload) {
        state.data.payment_card.balance_transfer_regular_apr_detail = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE](state, payload) {
        state.data.payment_card.balance_transfer_regular_rate_type = payload
    },
    [types.PAYMENT_CARD_PENALTY_APR](state, payload) {
        state.data.payment_card.PenaltyAPR = payload
    },
    [types.PAYMENT_CARD_PENALTY_APR_DETAILS](state, payload) {
        state.data.payment_card.PenaltyAPRDetails = payload
    },
    [types.PAYMENT_CARD_TIER_1_ANNUAL_FEE](state, payload) {
        state.data.payment_card.tier_1_annual_fee = payload
    },
    [types.PAYMENT_CARD_TIER_2_ANNUAL_FEE](state, payload) {
        state.data.payment_card.tier_2_annual_fee = payload
    },
    [types.PAYMENT_CARD_TIER_3_ANNUAL_FEE](state, payload) {
        state.data.payment_card.tier_3_annual_fee = payload
    },
    [types.PAYMENT_CARD_ANNUAL_FEE_DETAILS](state, payload) {
        state.data.payment_card.annual_fee_details = payload
    },
    [types.PAYMENT_CARD_TIER_1_LATE_FEE](state, payload) {
        state.data.payment_card.tier_1_late_fee = payload
    },
    [types.PAYMENT_CARD_TIER_2_LATE_FEE](state, payload) {
        state.data.payment_card.tier_2_late_fee = payload
    },
    [types.PAYMENT_CARD_TIER_3_LATE_FEE](state, payload) {
        state.data.payment_card.tier_3_late_fee = payload
    },
    [types.PAYMENT_CARD_LATE_FEE_DETAILS](state, payload) {
        state.data.payment_card.late_fee_details = payload
    },
    [types.PAYMENT_CARD_TIER_1_OVERLIMIT_FEE](state, payload) {
        state.data.payment_card.tier_1_overlimit_fee = payload
    },
    [types.PAYMENT_CARD_TIER_2_OVERLIMIT_FEE](state, payload) {
        state.data.payment_card.tier_2_overlimit_fee = payload
    },
    [types.PAYMENT_CARD_TIER_3_OVERLIMIT_FEE](state, payload) {
        state.data.payment_card.tier_3_overlimit_fee = payload
    },
    [types.PAYMENT_CARD_OVERLIMIT_FEE_DETAILS](state, payload) {
        state.data.payment_card.overlimit_fee_details = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_USAGE_FEE](state, payload) {
        state.data.payment_card.balance_transfer_usage_fee = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_MINIMUM_FEE](state, payload) {
        state.data.payment_card.balance_transfer_minimum_fee = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE](state, payload) {
        state.data.payment_card.balance_transfer_maximun_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_USAGE_FEE](state, payload) {
        state.data.payment_card.cash_advance_usage_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_MINIMUM_FEE](state, payload) {
        state.data.payment_card.cash_advance_minimum_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_MAXIMUM_FEE](state, payload) {
        state.data.payment_card.cash_advance_maximum_fee = payload
    },
    [types.PAYMENT_CARD_MINIMUM_CARD_LIMIT](state, payload) {
        state.data.payment_card.minimum_card_limit = payload
    },
    [types.PAYMENT_CARD_MAXIMUM_CARD_LIMIT](state, payload) {
        state.data.payment_card.maximum_card_limit = payload
    },
    [types.PAYMENT_CARD_MONTHLY_MAINTENENCE_FEE](state, payload) {
        state.data.payment_card.MonthlyMaintenanceFee = payload
    },
    [types.PAYMENT_CARD_STANDARD_MONTHLY_MAINTENENCE_FEE](state, payload) {
        state.data.payment_card.StandardMonthlyMaintenanceFee = payload
    },
    [types.PAYMENT_CARD_PURCHASE_INTRODUCTORY_APR](state, payload) {
        state.data.payment_card.purchase_introductory_apr = payload
    },
    [types.PAYMENT_CARD_PURCHASE_INTRODUCTORY_PERIOD_MONTHS](state, payload) {
        state.data.payment_card.purchase_introductory_period_months = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_APR](state, payload) {
        state.data.payment_card.balance_transfer_introductory_apr = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_PERIOD_MONTHS](state, payload) {
        state.data.payment_card.balance_transfer_introductory_period_months = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.payment_card.balance_transfer_introductory_usage_fee = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.payment_card.balance_transfer_introductory_minimum_fee = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE](state, payload) {
        state.data.payment_card.balance_transfer_introductory_maximum_fee = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD_MONTHS](state, payload) {
        state.data.payment_card.balance_transfer_introductory_fee_period_months = payload
    },
    [types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_DETAILS](state, payload) {
        state.data.payment_card.balance_transfer_introductory_fee_details = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_APR](state, payload) {
        state.data.payment_card.cash_advance_introductory_apr = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_PERIOD_MONTHS](state, payload) {
        state.data.payment_card.cash_advance_introductory_period_months = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE](state, payload) {
        state.data.payment_card.cash_advance_introductory_usage_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE](state, payload) {
        state.data.payment_card.cash_advance_introductory_minimum_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE](state, payload) {
        state.data.payment_card.cash_advance_introductory_maximum_fee = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD_MONTHS](state, payload) {
        state.data.payment_card.cash_advance_introductory_fee_period_months = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_DETAILS](state, payload) {
        state.data.payment_card.cash_advance_introductory_fee_details = payload
    },
    [types.PAYMENT_CARD_TIER_1_CASH_ADVANCE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_1_cash_advance_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_2_CASH_ADVANCE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_2_cash_advance_regular_apr = payload
    },
    [types.PAYMENT_CARD_TIER_3_CASH_ADVANCE_REGULAR_APR](state, payload) {
        state.data.payment_card.tier_3_cash_advance_regular_apr = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_REGULAR_APR_DETAILS](state, payload) {
        state.data.payment_card.cash_advance_regular_apr_details = payload
    },
    [types.PAYMENT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE](state, payload) {
        state.data.payment_card.cash_advance_regular_rate_type = payload
    },
    [types.PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER](state, payload) {
        state.data.payment_card.promotional_purchase_pricing_usage_offer = payload
    },
    [types.PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER_MONTHS](state, payload) {
        state.data.payment_card.promotional_purchase_pricing_usage_offer_months = payload
    },

    [types.RETAIL_CREDIT_CARD_MENTIONED](state, payload) {
        state.data.retail.credit_card_mentioned = payload
    },

    [types.TELECOM_PLAN_FEATURED](state, payload) {
        state.data.telecom.plan_featured = payload
    },
    [types.TELECOM_FEATURED_PLAN_NAME](state, payload) {
        state.data.telecom.featured_plan_name = payload
    },
    [types.TELECOM_CONTRACT_REQUIRED](state, payload) {
        state.data.telecom.contract_required = payload
    },
    [types.TELECOM_INTERNET_SPEED](state, payload) {
        state.data.telecom.internet_speed = payload
    },
    [types.TELECOM_MONTHLY_COST](state, payload) {
        state.data.telecom.monthly_cost = payload
    },
    [types.TELECOM_LOWER_FEATURED_MONTHLY_COST](state, payload) {
        state.data.telecom.lower_featured_monthly_cost = payload
    },
    [types.TELECOM_UPPER_FEATURED_MONTHLY_COST](state, payload) {
        state.data.telecom.upper_featured_monthly_cost = payload
    },
    [types.TELECOM_ACTIVATION_CHARGE](state, payload) {
        state.data.telecom.activation_charge = payload
    },
    [types.TELECOM_INSTALLATION_CHARGE](state, payload) {
        state.data.telecom.installation_charge = payload
    },
    [types.TELECOM_LOCAL_CALLING_MONTHLY_CHARGE](state, payload) {
        state.data.telecom.local_calling_monthly_charge = payload
    },
    [types.TELECOM_LOCAL_DISTANCE_MONTHLY_CHARGE](state, payload) {
        state.data.telecom.local_distance_monthly_charge = payload
    },
    [types.TELECOM_LONG_DISTANCE_MONTHLY_CHARGE](state, payload) {
        state.data.telecom.long_distance_monthly_charge = payload
    },
    [types.TELECOM_INTRODUCTORY_COST](state, payload) {
        state.data.telecom.introductory_cost = payload
    },
    [types.TELECOM_INTRODUCTORY_PERIOD_MONTHS](state, payload) {
        state.data.telecom.introductory_period_months = payload
    },

    [types.TRAVEL_DEBIT_CARD_MENTIONED](state, payload) {
        state.data.travel.debit_card_mentioned = payload
    },
    [types.TRAVEL_CREDIT_CARD_MENTIONED](state, payload) {
        state.data.travel.credit_card_mentioned = payload
    },
    [types.TRAVEL_CREDIT_NETWORK](state, payload) {
        state.data.travel.credit_network = payload
    },
    [types.PRODUCT_VARIENT_ENTRY_ID](state, payload) {
        state.data.varient_entry_id = payload
    },
    [types.PRODUCT_VARIENT_TYPE](state, payload) {
        state.data.varient_type = payload
    },
    [types.MUID](state, payload) {
        state.data.muid = payload
    },
    [types.USERID](state, payload) {
        state.data.userid = payload
    },
    [types.REMOVE_PANELIST](state, payload) {
        let arr = new Array(),
            pan = state.data.panelists
        if (pan !== null) {
            if (pan.length > 0) {
                pan.forEach(function (o) {
                    if (!(payload.competi_id === o.competi_id && payload.invitation_id === o.invitation_id && payload.panelist_id === o.panelist_id && payload.pp_date === o.pp_date && payload.tracking_id === o.tracking_id)) {
                        arr.push(o)
                    }
                })
                state.data.panelists = arr
            }
        }
    },
    [types.EDIT_PANELIST](state, payload) {
        state.data.panelists[payload.index][payload.key] = payload.val
    },
    [types.ADD_PUBLICATION](state, payload) {
        state.data.publication.push(payload)
    },
    [types.REMOVE_PUBLICATION](state, payload) {
       state.data.publication = state.data.publication.filter(o => ((o.publication_id !== payload.publication_id) || (o.publication_date !== payload.publication_date)))
    },
    [types.REMOVE_BANKING](state) {
        let newBanking = {
            reward_program_emphasis: '',
            reward_program: '',
            card_type: '',
            debit_card_mentioned: '',
            cd_apy: '',
            cd_apr: '',
            money_market_apy: '',
            money_market_apr: '',
            saving_apy: '',
            saving_apr: '',
            checking_apy: '',
            checking_apr: '',
            free_checking: '',
            minimum_deposit: '',
        }
        state.data.banking = newBanking
    },
    [types.REMOVE_PAYMENT_CARDS](state) {
        let newPaymentCard = {
            application_type: '',
            card_network: '',
            primary_card_level: '',
            secondary_card_level: '',
            reward_program: '',
            reward_program_emphasis: '',
            reward_program_rate: '',
            reloadable: '',
            tier_1_purchase_regular_apr: '',
            tier_2_purchase_regular_apr: '',
            tier_3_purchase_regular_apr: '',
            purchase_regular_apr_detail: '',
            perchase_regular_rate_type: '',
            tier_1_balance_transfer_regular_apr: '',
            tier_2_balance_transfer_regular_apr: '',
            tier_3_balance_transfer_regular_apr: '',
            balance_transfer_regular_apr_detail: '',
            balance_transfer_regular_rate_type: '',
            PenaltyAPR: '',
            PenaltyAPRDetails: '',
            tier_1_annual_fee: '',
            tier_2_annual_fee: '',
            tier_3_annual_fee: '',
            annual_fee_details: '',
            tier_1_late_fee: '',
            tier_2_late_fee: '',
            tier_3_late_fee: '',
            late_fee_details: '',
            tier_1_overlimit_fee: '',
            tier_2_overlimit_fee: '',
            tier_3_overlimit_fee: '',
            overlimit_fee_details: '',
            balance_transfer_usage_fee: '',
            balance_transfer_minimum_fee: '',
            balance_transfer_maximun_fee: '',
            cash_advance_usage_fee: '',
            cash_advance_minimum_fee: '',
            cash_advance_maximum_fee: '',
            minimum_card_limit: '',
            maximum_card_limit: '',
            purchase_introductory_apr: '',
            purchase_introductory_period_months: '',
            balance_transfer_introductory_apr: '',
            balance_transfer_introductory_period_months: '',
            balance_transfer_introductory_usage_fee: '',
            balance_transfer_introductory_minimum_fee: '',
            balance_transfer_introductory_maximum_fee: '',
            balance_transfer_introductory_fee_period_months: '',
            balance_transfer_introductory_fee_details: '',
            cash_advance_introductory_apr: '',
            cash_advance_introductory_period_months: '',
            cash_advance_introductory_usage_fee: '',
            cash_advance_introductory_minimum_fee: '',
            cash_advance_introductory_maximum_fee: '',
            cash_advance_introductory_fee_period_months: '',
            cash_advance_introductory_fee_details: '',
            promotional_purchase_pricing_usage_offer: '',
            promotional_purchase_pricing_usage_offer_months: ''
        }
        state.data.payment_card = newPaymentCard
    },
    [types.REMOVE_CREDIT_CARDS](state) {
        let newCreditCard = {
            promotional_offer: false,
            tier_1_balance_transfer_introduction_apr: '',
            tier_1_balance_transfer_introductory_period: '',
            tier_2_balance_transfer_introduction_apr: '',
            tier_2_balance_transfer_introductory_period: '',
            balance_transfer_introductory_usage_fee: '',
            balance_transfer_introductory_minimum_fee: '',
            balance_transfer_introductory_maximum_fee: '',
            balance_transfer_introductory_fee_period: '',

            tier_1_cash_advance_introductory_apr: '',
            tier_1_cash_advance_introductory_period: '',
            tier_2_cash_advance_introductory_apr: '',
            tier_2_cash_advance_introductory_period: '',
            cash_advance_introductory_usage_fee: '',
            cash_advance_introductory_minimum_fee: '',
            cash_advance_introductory_maximum_fee: '',
            cash_advance_introductory_fee_period: '',

            tier_1_purchase_introductory_apr: '',
            tier_1_purchase_introductory_period: '',
            tier_2_purchase_introductory_apr: '',
            tier_2_purchase_introductory_period: '',
            purchase_introductory_usage_fee: '',
            purchase_introductory_minimum_fee: '',
            purchase_introductory_maximum_fee: '',
            purchase_introductory_fee_period: '',
            balance_transfer_regular_apr: '',
            balance_transfer_regular_rate_type: '',
            balance_transfer_usage_fee: '',
            balance_transfer_minimum_fee: '',
            balance_transfer_maximum_fee: '',
            cash_advance_regular_apr: '',
            cash_advance_regular_rate_type: '',
            cash_advance_usage_fee: '',
            cash_advance_minimum_fee: '',
            cash_advance_maximum_fee: '',
            perchase_regular_apr: '',
            perchase_regular_rate_type: '',
        }
        state.data.credit_card = newCreditCard
    },
    [types.REMOVE_ENERGY](state) {
        let newEnergy = {
            offer_price_per_kwh: '',
            offer_price_per_kwh2: '',
            offer_price_per_kwh3: '',
            offer_price_per_kwh4: '',
            term_length: '',
            term_length2: '',
            term_length3: '',
            term_length4: '',
            cancel_fee: '',
            cancel_fee_details: '',
            rate_type: '',
            rate_type2: '',
            rate_type3: '',
            rate_type4: '',
        }
        state.data.energy = newEnergy
    },
    [types.REMOVE_MORTGAGE](state) {
        let newMortgage = {
            refinance: '',
            jumbo_non_conforming: '',
            va: '',
            fha: '',
            conventional: '',
            usda: '',
            correspondent_lending: '',
            application_type: '',
            offered_loan_amount: '',
            maximum_loan_amount: '',
            minimum_loan_amount: '',
            loan_term_months: '',
            offered_apr: '',
            upper_apr: '',
            lower_apr: '',
            rate_type: '',
            introductory_apr: '',
            introductory_period_months: '',
        }
        state.data.mortgage_loans = newMortgage
    },
    [types.REMOVE_RETAIL](state) {
        let newRetail = {
            credit_card_mentioned: '',
        }
        state.data.retail = newRetail
    },
    [types.REMOVE_TELECOM](state) {
        let newTelecom = {
            plan_featured: '',
            featured_plan_name: '',
            contract_required: '',
            internet_speed: '',
            monthly_cost: '',
            lower_featured_monthly_cost: '',
            upper_featured_monthly_cost: '',
            activation_charge: '',
            installation_charge: '',
            local_calling_monthly_charge: '',
            long_distance_monthly_charge: '',
            introductory_cost: '',
            introductory_period_months: '',
        }
        state.data.telecom = newTelecom
    },
    [types.REMOVE_TRAVEL](state) {
        let newTravel = {
            debit_card_mentioned: '',
            credit_card_mentioned: '',
            credit_network: [],
        }
        state.data.travel = newTravel
    },
    [types.PRODUCT_ID](state, payload) {
        state.data.product_id = payload
    },
    [types.COMPANY_IMG_DATA](state, payload) {
        state.company_img_data.push(payload)
    },
    [types.COMPANY_ASSOCIATED_DATA](state, payload) {
        state.company_associated_data = payload
    },
    [types.CURRENT_COMPANY_PATH](state, payload) {
        state.current_company_path = payload
    },
    [types.CURRENT_COMPANY_ID](state, payload) {
        state.current_company_id = payload
    },
    [types.LAST_WORKED_USER](state, payload) {
        state.last_worked_user = payload
    },
    [types.INDEX_NAME](state, payload) {
        state.data.index_name = payload
    }, [types.PRODUCT_STATUS](state, payload) {
        state.data.product_status = payload
    },
    [types.PRODUCT_PRODUCT_COMMENT](state, payload) {
        state.data.product_comment = payload
    },
    [types.IS_ADDPRODUCT](state, payload) {
        state.data.is_addproduct = payload
    },
    [types.EC_CONTENT_TYPE](state, payload) {
        state.data.ec_content_type = payload
    },

    // advertiser

    [types.ADVERTISER_ADDRESS](state, payload) {
        state.data.advertiser.address = payload
    },
    [types.ADVERTISER_CITY](state, payload) {
        state.data.advertiser.city = payload
    },
    [types.ADVERTISER_STATE](state, payload) {
        state.data.advertiser.state_province = payload
    },
    [types.ADVERTISER_ZIPCODE](state, payload) {
        state.data.advertiser.zipcode = payload
    },
    [types.ADVERTISER_PHONE](state, payload) {
        state.data.advertiser.phone = payload
    },
    [types.ADVERTISER_URL](state, payload) {
        state.data.advertiser.url = payload
    },

    // PROMOTIONS

    [types.HOLIDAY](state, payload) {
        state.data.promotion_other_fields.holiday = payload
    },
    [types.SALE_TYPE](state, payload) {
        state.data.promotion_other_fields.sale_type = payload
    },
    [types.PROMOTIONS](state, payload) {
        state.data.promotions = payload
    },
    [types.PDF_CONTENT](state, payload) {
        state.data.pdf_content = payload
    },
    [types.CURRENT_PDF](state, payload) {
        state.data.current_pdf = payload
    },
    [types.ENTRY_ID](state, payload) {
        if (payload === null) {
            payload = ''
        }
        state.data.entry_id = payload
    },
    [types.ENTRY_DATE_CHANGED](state, payload) {
        state.data.entry_date_changed = payload
    },
    [types.MOBILE_DIGITAL_FILE_URL](state, payload) {
        state.data.mobile_digital_file_url = payload
    },
    [types.MOBILE_DIGITAL_FILE_TYPE](state, payload) {
        state.data.mobile_digital_file_type = payload
    },
    [types.MOBILE_DIGITAL_FILE_SIZE](state, payload) {
        state.data.mobile_digital_file_size = payload
    },
    [types.MEDIA_CHANNEL_NAME](state, payload) {
        state.data.medial_channel_name = payload
    },
    [types.BANNER_PRODUCT_PATH](state, payload) {
        state.data.banner_product_path = payload
    },
    [types.DOCUMENT_SIZE_BYTE](state, payload) {
        state.data.document_size_byte = payload
    },
    [types.ORIGINAL_DOCUMENT_SIZE](state, payload) {
        state.data.original_document_size = payload
    },
    [types.IS_MOBILE](state, payload) {
        state.data.is_mobile = payload
    },
    [types.FILE_NAME](state, payload) {
        state.data.file_name = payload
    },
    [types.PDF_CDN_LINK](state, payload) {
        state.data.pdf_cdn_link = payload
    },
    [types.PDF_CDN_LINK_ORIG](state, payload) {
        state.data.pdf_cdn_link_orig = payload
    },
    [types.IS_DELETED](state, payload) {
        state.data.is_deleted = payload
    },
    [types.DIRECT_MAIL_LOGFILE](state, payload) {
        state.data.direct_mail_logfile = payload
    },
    [types.ADDED_TO_DATABASE](state, payload) {
        state.data.added_to_database = payload
    },
}

export default mutations
